import { EnvironmentActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const EnvironmentReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case EnvironmentActionType.Environment_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default EnvironmentReducer
